__webpack_require__.p = "https://devicereleasenotes.amazon/";